// use to replace template config key
// will extended when new template add
export const getConfigKeyData = accountData => ({
    accountCurrency: accountData.currency,
});
